import { Box } from "@chakra-ui/react";
import { useMainChatContext } from "@root/context/kps-chat-context";
import ProjectsListing from "@root/components/dashboard/ProjectsListing";
import ChatSources from "./ChatSources";

const ChatRightPanel = () => {
  const { openProjectsListing, sourcesData } = useMainChatContext();
  const isPanelVisible = openProjectsListing || sourcesData;

  function renderContent() {
    if (openProjectsListing) {
      return <ProjectsListing />;
    }
    if (sourcesData) {
      return <ChatSources />;
    }
    return null;
  }

  if (!isPanelVisible) {
    return null;
  }

  return (
    <Box
      className="right-sidebar"
      position={"fixed"}
      right={0}
      top={0}
      bottom={0}
      bgColor={"white"}
      width={"400px"}
      // zIndex={10}
      border={"1px solid #CDD6DC"}
      boxShadow={"-4px 0px 12px -4px #4E4E4E33;"}
    >
      {renderContent()}
    </Box>
  );
};

export default ChatRightPanel;
